export default __webpack_public_path__ + "static/media/doc-transparent-About-us-page.291d730f.png";